import Box from "@material-ui/core/esm/Box";
import DirectionsCarOutlined from "@material-ui/icons/esm/DirectionsCarOutlined";
import Info from "@material-ui/icons/esm/Info";
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { useRecoilState, useRecoilValueLoadable } from 'recoil';
import { showCheckboxColumn, passingsToExport } from 'api/passings/getFilteredPassings';
import { getPassingsForInvoice, passingsForInvoiceObeNumber, passingsForInvoicePagination } from 'api/passings/getPassingsForInvoice';
import { PrimaryButton, SecondaryButton } from 'components/Button';
import ChooseTag from 'components/ChooseTag/ChooseTag';
import InfoBox from 'components/InfoBox/InfoBox';
import Pagination from 'components/Pagination/Pagination';
import PassingList from 'components/PassingsList/PassingList';
import PeriodFilter from 'components/PeriodFilter/PeriodFilter';
import Spinner from 'components/Spinner/Spinner';
import { Title } from 'components/Text';
import { PASSINGS_PATH } from 'routes/passings/paths';
import checkLoadable from 'utils/recoil/checkLoadable';
import InvoicePassingsDownload from './InvoicePassingsDownload';
import useStyles from './InvoicePassingsStyles';
export default function InvoicePassings({
  invoiceId,
  invoiceNumber,
  agreementName,
  isInvoiceArchived
}) {
  const {
    t
  } = useTranslation();
  const {
    exportCustomButton
  } = useStyles();
  const {
    push
  } = useHistory();
  const [obeNumber, setObeNumber] = useRecoilState(passingsForInvoiceObeNumber);
  const [pagination, setPagination] = useRecoilState(passingsForInvoicePagination);
  const passingsLoadable = useRecoilValueLoadable(getPassingsForInvoice(invoiceId));
  const {
    contents: passings,
    loading
  } = checkLoadable(passingsLoadable);
  const handlePeriodFilterChange = ({
    startDate,
    endDate
  }) => {
    setPagination(currentValue => ({
      ...currentValue,
      dateFrom: startDate?.toDate(),
      dateTo: endDate?.toDate()
    }));
  };
  const hasPassings = passings?.totalResults !== 0;
  const [showCheckbox, setShowCheckbox] = useRecoilState(showCheckboxColumn);
  const [passingsToExportLst, setPassingsToExport] = useRecoilState(passingsToExport);
  const handleSpecificExportButtonOnClick = () => {
    if (showCheckbox) {
      setPassingsToExport([]);
    }
    setShowCheckbox(!showCheckbox);
  };
  useEffect(() => {
    setPassingsToExport([]);
    setShowCheckbox(false);
  }, []);
  let content;
  if (isInvoiceArchived) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(InfoBox, {
      mb: 3
    }, /*#__PURE__*/React.createElement(Box, {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      paddingLeft: 2
    }, /*#__PURE__*/React.createElement(Box, {
      display: "flex",
      alignItems: "center",
      gridColumnGap: 8
    }, /*#__PURE__*/React.createElement(Info, null), t('passings.invoice_archived_info')))), /*#__PURE__*/React.createElement(SecondaryButton, {
      startIcon: /*#__PURE__*/React.createElement(DirectionsCarOutlined, null),
      onClick: () => push(PASSINGS_PATH)
    }, t('passings.go_to_passings')));
  }
  if (loading) content = /*#__PURE__*/React.createElement(Spinner, null);else if (!hasPassings) content = /*#__PURE__*/React.createElement(Title, {
    align: "center"
  }, t('passings.no_passing'));else {
    content = /*#__PURE__*/React.createElement(PassingList, {
      items: passings?.results ?? []
    });
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(PeriodFilter, {
    onChange: handlePeriodFilterChange,
    useUtc: true
  }), /*#__PURE__*/React.createElement(ChooseTag, {
    setObeNumber: newObeNumber => setObeNumber(newObeNumber)
  }), /*#__PURE__*/React.createElement("div", {
    className: exportCustomButton
  }, /*#__PURE__*/React.createElement(PrimaryButton, {
    onClick: () => handleSpecificExportButtonOnClick()
  }, t('passings.export_specific_passings'))), /*#__PURE__*/React.createElement(InvoicePassingsDownload, {
    disabled: loading || !hasPassings,
    invoiceId: invoiceId,
    agreementName: agreementName,
    invoiceNumber: invoiceNumber,
    dates: {
      dateFrom: pagination.dateFrom,
      dateTo: pagination.dateTo
    },
    max: passings?.totalResults ?? pagination.max,
    obeNumber: obeNumber ?? '',
    showCheckbox: showCheckbox,
    accountId: passings?.results?.[0]?.accountId
  }), content, /*#__PURE__*/React.createElement(Pagination, {
    totalResults: passings?.totalResults ?? 0,
    handlePagination: setPagination,
    paginationParams: pagination,
    rowsPerPageOptions: [5, 10, 30, 100]
  }));
}